import React from 'react';
import Select from 'react-select';

/**
 *  Select component
 * @param {*} param0
 */
const RenderSelect = ({
    input,
    label,
    options,
    isMulti,
    className = '',
    meta: { touched, error, warning },
}) => {
    return (
        <>
            <Select
                options={options}
                placeholder="Select Industry"
                onChange={(value) => input && input.onChange(value)}
                isMulti={isMulti}
                className={
                    touched && error ? className + ' inf-error' : className
                }
            />
            {touched &&
                ((error && <span className="input-error">{error}</span>) ||
                    (warning && <span>{warning}</span>))}
        </>
    );
};

export default RenderSelect;
